import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectPlatformsPage = lazy(
  () => import('~/features/onboarding/pages/connect-platforms-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/onboarding/integration/google/')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectPlatformsPage />
    </Suspense>
  ),
});
